export default __webpack_public_path__ + "static/media/aspacierre.260e76a4.svg";